module.exports = "/assets/data/dfad38bcbabb5ddd5be146e9c1cca94d-YO10.data.json";